import React from "react";
import ContentBox from "../../components/UI/ContentBox";
import Footer from "../../components/UI/Footer";
import Menu from "../../components/UI/Menu";
import {
  Container,
  LinkDoc,
  Text,
} from "./styles";
import Banner from "../../components/UI/Banner";
import { images } from "../../constants";
import cidadeLeitora from "../../assets/docs/cidadeLeitora.pdf";

const ProjectReaderCity = () => {
  
  const openPadletCid = () => {
    window.open("https://padlet.com/cidadeleitora1/projeto-mogi-cidade-leitora-lhzi9bsbkbrhd2q0");
  };

  return (
  
    <Container>
      <Menu />
      <Banner icon={images.icon_cidadeleitora}>MOGI CIDADE LEITORA</Banner>
      <ContentBox>

            <Text>
              Neste projeto, pretende-se criar condições para que o prazer da leitura faça parte da vida de todos,
            não só durante as aulas e nas escolas, mas como um ato constituído por diversas ações, possibilitando
            a vivência de um panorama diversificado da leitura e da literatura em nossa cidade.
            </Text>
            

          <LinkDoc href={cidadeLeitora} target="_blank">* Conheça o projeto (Clique aqui)</LinkDoc>
          <LinkDoc onClick={openPadletCid}>*Visite o mural virtual do projeto e conheça suas ações (Clique aqui)</LinkDoc>

          <iframe width="600" height="338" src="https://www.youtube.com/embed/9R0UKlXFcrk" title="Encerramento do Projeto Mogi, Cidade Leitora - 2024" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          <iframe width="600" height="338" src="https://www.youtube.com/embed/v8emKXicbEY" title="Encerramento do Projeto Mogi, Cidade Leitora - 2023" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </ContentBox>
      <Footer />
    </Container>
  );
};

export default ProjectReaderCity;